export default "__VITE_ASSET__DJ4u2$rZ__"